import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SiteZoneDto} from '../components/selection-zone/model/site-zone.dto';

@Injectable({
	providedIn: 'root'
})
export class SiteService {
	private url = '/ws/sites';

	constructor(private http: HttpClient) {
	}

	/**
	 * Recherche les zones privées.
	 */
	rechercherZonesPrivees(): Observable<SiteZoneDto[]> {
		const params = new HttpParams()
			.set('use-case', 'zones-privees');
		return this.http.get<SiteZoneDto[]>(`${this.url}`, {params: params});
	}
}
